module.exports = __webpack_public_path__ + "img/bam_logo.7cbed580.png";